import Component from '../abstracts/Component';
const { Crawler } = require('./../../../../node_modules/es6-crawler-detect/src');
export default class GoogleRecommendationEngineComponent extends Component {

  static get SELECTORS() {
    return {
      RECOMMENDATION_ENGINE_CONTAINER: '[data-google-recommendation-engine]',
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER: '[data-google-recommendation-engine-products]',
      RECOMMENDATION_TITLE: '[data-google-recommendation-title]',
      RECOMMENDATION_TITLE_CONTENT: '[data-google-recommendation-title-content]',
      carouselCards: '#googleCarouselCards',
      nextArrow: '[data-google-carousel-arrow-right]',
      prevArrow: '[data-google-carousel-arrow-left]'
    };
  }

  static get CONSTANTS() {
    let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
    return {
      RECOMMENDATION_ENGINE_URL: contextPath + "/action/recommendation-google",
      GET: "GET",
      POST: "POST",
      CHECKOUT_TEMPLATE: "t-checkout-confirm"
    };
  }

  render() {
    this.importSlick();
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);
    if (recommendationComponent != null) {
      this.setup(recommendationComponent);
    }
  }

  constructor(compEl) {
    super(compEl);
    this.recommendationEngineProductsContainer = this.$component.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
    this.slickLoaded = false; // Flag to check if Slick is loaded
    this.pendingCarouselData = null; // Store carousel data for later initialization
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    let template = recommendationComponent.dataset.template;
    let checkoutTemplate = GoogleRecommendationEngineComponent.CONSTANTS.CHECKOUT_TEMPLATE;
    opts.template = template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.orderCode = recommendationComponent.dataset.orderCode;
    opts.saleMode = recommendationComponent.dataset.salemode;
    if (typeof (utag_data) !== 'undefined' && utag_data !== null && template === checkoutTemplate) {
      let products = utag_data.products;
      if (typeof (products) !== 'undefined' && products !== null) {
        try {
          opts.productsData = JSON.stringify(products);
        } catch (e) {
          this.warn("error trasform products to JSON");
        }
      }
      if (typeof (utag_data.order_total) !== 'undefined' && utag_data.order_total !== null) opts.totalPrice = utag_data.order_total;
    }
    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  callServer(paramsObj, callBackOnSuccess, callBackOnFailure, timeoutTime) {
    let xhttp = new XMLHttpRequest();
    let params = new URLSearchParams();
    let template = "";
    let products = "";
    let checkoutTemplate = GoogleRecommendationEngineComponent.CONSTANTS.CHECKOUT_TEMPLATE;

    // Loop through paramsObj to build the URLSearchParams object
    for (let key in paramsObj) {
      let value = paramsObj[key];
      if (key === "template") {
        template = value;
      }
      if (key === "productsData") {
        products = value;
      }
      // Append all parameters to the URLSearchParams object
      params.append(key, value);
    }

    // If timeoutTime is provided, set it for the request
    if (timeoutTime != null) {
      // Set timeout for the request
      xhttp.timeout = timeoutTime;
    }

    // Handles the configuration of the HTTP request according to the template type
    if (template === checkoutTemplate) {
      xhttp.open(GoogleRecommendationEngineComponent.CONSTANTS.POST, GoogleRecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20"), true);
    } else {
      xhttp.open(GoogleRecommendationEngineComponent.CONSTANTS.GET, GoogleRecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20"), true);
    }

    // Event handler which handles status changes of the XMLHttpRequest and is called by browser automatically whenever the status of the HTTP request changes
    // Check if the request is complete
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        callBackOnSuccess(this);
      } else {
        if (this.readyState === 4 && (this.status === 204 || this.status === 500 || this.status === 404 || this.status === 302)) {
          callBackOnFailure();
        }
      }
    };

    // Handle timeout
    xhttp.ontimeout = function () {
      console.log("Google rec. timeout reached..");
      callBackOnFailure();
    };

    // Handle network errors
    xhttp.onerror = function () {
      console.log("Google rec. error occurred..");
      callBackOnFailure();
    };

    // If template is checkout, send products data in POST request
    if (template === checkoutTemplate) {
      xhttp.send(products);
    } else {
      // For other templates, send GET request
      xhttp.send();
    }
  }

  moduleTitle() {
    const googleModel = this.$component.querySelector("#googleRecommendationModel");
    const googleTitle = this.$component.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_TITLE_CONTENT);
    if (typeof (googleModel) !== 'undefined' && googleModel !== null && googleModel.value !== '' && typeof (googleTitle) !== 'undefined' && googleTitle !== null) {
      googleTitle.innerHTML = googleModel.value;
    }
  }

  renderData(data) {
    let recommendationProductsComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
    let recommendationTitle = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_TITLE);

    if (recommendationProductsComponent != null) {
      recommendationProductsComponent.innerHTML = data.responseText;
      if (data.responseText.trim() != '') {
        $(recommendationTitle).css('display', 'flex');
      }
      this.moduleTitle();
    }
    this.recommendationEngineProductsContainer = data.responseText;
    // Parse the response text to find the carousel container
    // This is necessary because the response might not be in the live DOM yet
    const htmlRes = new DOMParser().parseFromString(this.recommendationEngineProductsContainer, 'text/html');
    // Find the carousel container in the parsed HTML
    const carouselContainer = htmlRes.querySelector(GoogleRecommendationEngineComponent.SELECTORS.carouselCards);
    // We also check whether the carousel is now in the live DOM
    const liveCarouselContainer = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.carouselCards);
    // Check if Slick is loaded, if not store the data for later
    if (this.slickLoaded) {
      // Use the container from the live DOM if available, otherwise the parsed one
      const containerToUse = liveCarouselContainer || carouselContainer;
      if (containerToUse) {
        // Add a small delay to ensure the DOM is fully updated
        setTimeout(() => {
          this.initCarousel(containerToUse);
        }, 50);
      }
    } else {
      // If Slick is not loaded yet, store the carousel data for later initialization
      // This allows us to initialize the carousel once Slick is available
      console.log('Google Slick not loaded yet, storing carousel data for later initialization');
      this.pendingCarouselData = liveCarouselContainer || carouselContainer;
    }
  }

  tryAgain() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);
    this.callServer(
      this.getSimilarOpts(recommendationComponent),
      this.renderData.bind(this),
      this.hideComponent.bind(this),
      null
    );
  }

  hideComponent() {
    let recommendationComponent = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER);
    if (recommendationComponent != null) {
      recommendationComponent.innerHTML = '';
    }
  }

   // handle carousel
   initCarousel(carouselContainer) {
    // Check if Slick is available and carouselContainer exists
    if (!carouselContainer) {
      console.warn('Google carousel container not found');
      return;
    }
    // If Slick is not loaded, defer initialization
    if (typeof $ === 'undefined' || typeof $.fn.slick === 'undefined') {
      console.warn('Google Slick library not available, deferring carousel initialization');
      this.pendingCarouselData = carouselContainer;
      return;
    }
    // Find the correct container in the live DOM
    const liveCarouselContainer = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.carouselCards);
    const containerToUse = liveCarouselContainer || carouselContainer;
    if (!containerToUse) {
      console.warn('No valid Google carousel container found in DOM');
      return;
    }

    const templatePage = document.querySelector(GoogleRecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_CONTAINER).dataset.template;
    const productCards = containerToUse.querySelectorAll(".w-carousel__item");
    const nextArrow = this.$component.querySelector(GoogleRecommendationEngineComponent.SELECTORS.nextArrow);
    const prevArrow = this.$component.querySelector(GoogleRecommendationEngineComponent.SELECTORS.prevArrow);

    // Find the .w-carousel__items element within the correct container
    const $carouselItems = $(containerToUse).find('.w-carousel__items');
    if (!$carouselItems.length) {
      console.warn('No .w-carousel__items found in Google container');
      return;
    }
    // Check if Slick is already initialized and destroy it
    if ($carouselItems.hasClass('slick-initialized')) {
      try {
        $carouselItems.slick('unslick');
      } catch (error) {
        console.warn('Error destroying existing Google slick:', error);
      }
    }
    // Initialize the carousel with appropriate options based on the number of product cards
    if(productCards.length >= 3) {
      if(productCards.length === 4) {
        const options2 = {
          mobileFirst: true,
          arrows: false,
          centerMode: true,
          centerPadding: "20px",
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          responsive: [
            {
              breakpoint: 1023,
              settings: 'unslick'
            },
            {
              breakpoint: 767,
              settings: {
                centerMode: false,
                arrows: true,
                slidesToShow: 3,
              },
            },
          ],
        };
        this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
        try {
          return $carouselItems.slick(options2);
        } catch (error) {
          console.error('Error initializing Google slick carousel:', error);
        }
      }
      if(productCards.length === 5) {
        if(templatePage === 't-myaccount-dashboard' || templatePage === 't-cart' || templatePage === 't-checkout-confirm') {
          const options3 = {
            mobileFirst: true,
            arrows: false,
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
              {
                breakpoint: 1023,
                settings: {
                  centerMode: false,
                  arrows: true,
                  slidesToShow: 4,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  centerMode: false,
                  arrows: true,
                  slidesToShow: 3,
                },
              },
            ],
          };
          this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
          try {
            return $carouselItems.slick(options3);
          } catch (error) {
            console.error('Error initializing Google slick carousel:', error);
          }
        } else { //homepage and pdp
          const options4 = {
            mobileFirst: true,
            arrows: false,
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
              {
                breakpoint: 1023,
                settings: 'unslick'
              },
              {
                breakpoint: 767,
                settings: {
                  centerMode: false,
                  arrows: true,
                  slidesToShow: 3,
                },
              },
            ],
          };
          this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
          try {
            return $carouselItems.slick(options4);
          } catch (error) {
            console.error('Error initializing Google slick carousel:', error);
          }
        }
      }
      if(productCards.length >= 6) {
        if(templatePage === 't-myaccount-dashboard' || templatePage === 't-cart' || templatePage === 't-checkout-confirm') {
          const options5 = {
            mobileFirst: true,
            arrows: false,
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 4,
                  centerMode: false,
                  arrows: true,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  centerMode: false,
                  arrows: true,
                  slidesToShow: 3,
                },
              },
            ],
          };
          this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
          try {
            return $carouselItems.slick(options5);
          } catch (error) {
            console.error('Error initializing Google slick carousel:', error);
          }
        } else { //homepage and pdp
          const options6 = {
            mobileFirst: true,
            arrows: false,
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            responsive: [
              {
                breakpoint: 1023,
                settings: {
                  slidesToShow: 5,
                  centerMode: false,
                  arrows: true,
                },
              },
              {
                breakpoint: 767,
                settings: {
                  centerMode: false,
                  arrows: true,
                  slidesToShow: 3,
                },
              },
            ],
          };
          this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
          try {
            return $carouselItems.slick(options6);
          } catch (error) {
            console.error('Error initializing Google slick carousel:', error);
          }
        }
      }
      const options1 = {
        mobileFirst: true,
        arrows: false,
        centerMode: true,
        centerPadding: "20px",
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        infinite: true,
        responsive: [
          {
            breakpoint: 767,
            settings: 'unslick'
          },
        ],
      };
      this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
      try {
        return $carouselItems.slick(options1);
      } catch (error) {
        console.error('Error initializing Google slick carousel:', error);
      }
    }

    if(productCards.length === 1 || productCards.length === 2) {
      this.$emit(this.$customEvents.RECOMMENDATION_ENGINE_EVENTS.updatedGoogle, { elem: $carouselItems });
    }

  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        // Slick is now loaded and ready
        this.slickLoaded = true;
        console.log('Google Slick library loaded successfully');
        // If there's pending carousel data, initialize it now
        if (this.pendingCarouselData) {
          // Add a small delay to ensure that the DOM is stable
          setTimeout(() => {
            this.initCarousel(this.pendingCarouselData);
            console.log('Google Slick carousel initialized with pending data');
            // Clear the pending data
            this.pendingCarouselData = null;
          }, 100);
        }
      },
      (error) => {
        console.error("Failed to load Google slick library:", error.stack);
        // Retry mechanism in case of loading failure
        setTimeout(() => {
          this.retrySlickLoading();
        }, 1000);
      },
    );
  }

  // Retry mechanism for loading Slick
  retrySlickLoading() {
    // Check if Slick is available
    // If Slick is loaded, initialize the carousel with pending data if available
    if (typeof $ !== 'undefined' && typeof $.fn.slick !== 'undefined') {
      this.slickLoaded = true;
      if (this.pendingCarouselData) {
        this.initCarousel(this.pendingCarouselData);
        this.pendingCarouselData = null;
      }
    } else {
      // If Slick is not loaded yet, log a message and retry
      // This allows us to retry loading Slick after a short delay
      console.log('Retrying Google Slick loading...');
      this.moduleLoader.loadCarouselAndExecute(
        () => {
          this.slickLoaded = true;
          if (this.pendingCarouselData) {
            setTimeout(() => {
              this.initCarousel(this.pendingCarouselData);
              this.pendingCarouselData = null;
            }, 100);
          }
        },
        (error) => {
          console.error('Google retry failed:', error);
        }
      );
    }
  }

  setup(recommendationComponent) {
    let timeout = recommendationComponent.dataset.timeout;
    let template = recommendationComponent.dataset.template;
    let CrawlerDetector = new Crawler();
    let userAgentString = navigator.userAgent;
    if (!CrawlerDetector.isCrawler(userAgentString)) {
      this.callServer(
        this.getMarketingOpts(recommendationComponent),
        this.renderData.bind(this),
        template === 't-product' ? this.tryAgain.bind(this) : this.hideComponent.bind(this),
        timeout
      );
    } else {
      this.hideComponent();
    }
  }

}
